import classNames from 'classnames';
import Iframe from 'react-iframe';

import type { UploadFileResult } from '@revelio/data-access';
import { Dialog } from '@revelio/ui';

import { ModalDownloadButton } from './ModalDownloadButton';
import styles from './ppt-preview-modal.module.css';
import modalStyles from './themedModal.module.css';

export type PptPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
} & Pick<UploadFileResult, 'previewUrl' | 'downloadUrl' | 'editUrl'>;

export const PptPreviewModal = ({
  isOpen,
  onClose,
  title,
  previewUrl,
  downloadUrl,
  editUrl,
}: PptPreviewModalProps) => {
  const iframeUrl = editUrl || previewUrl;
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={title}
      size="6xl"
      placement="top"
      className={classNames(modalStyles.content, styles.dialog)}
      bodyClassName={styles.body}
    >
      {downloadUrl && <ModalDownloadButton downloadUrl={downloadUrl} />}
      {iframeUrl && (
        <Iframe
          id="ds-frame"
          url={iframeUrl}
          width="100%"
          height="100%"
          position="relative"
          styles={{ border: 'none' }}
          allowFullScreen
          allow="storage-access *"
        />
      )}
    </Dialog>
  );
};
